import React from 'react';
import { discountLabel, originalPrice, price } from '../data/kit';
interface PriceTagProps {
  size?: 'md' | 'lg';
  align?: 'left' | 'center';
}
export function PriceTag({
  size = 'md',
  align = 'left'
}: PriceTagProps) {
  const big = size === 'lg' ? 'text-6xl sm:text-7xl' : 'text-5xl';
  const currency = size === 'lg' ? 'text-3xl sm:text-4xl' : 'text-xl';
  const justify = align === 'center' ? 'justify-center' : '';
  return <div data-id="element-285" data-mp="19vm9miz857mi">
      <div className={`flex flex-wrap items-center gap-2 ${justify}`} data-id="element-286" data-mp="19vuhtxkejord">
        <span className="text-lg font-semibold text-muted" data-id="element-287" data-mp="1eonq2vf2xf87">
          Antes <span className="line-through decoration-danger decoration-2" data-id="element-288" data-mp="10wqxkq9i13ba">{originalPrice} ARS</span>
        </span>
        <span className="rounded-full bg-danger px-2.5 py-0.5 font-display text-xs font-extrabold text-white" data-id="element-289" data-mp="14xay83ta6p26">
          {discountLabel}
        </span>
      </div>
      <div className={`mt-1 flex items-baseline gap-2 ${justify}`} data-id="element-290" data-mp="r0nqd5zsiehh">
        <span className="text-sm font-bold uppercase text-muted" data-id="element-291" data-mp="vwuyn5fns22l">Hoy</span>
        <span className={`font-display font-black tracking-tight text-brand ${big}`} data-id="element-292" data-mp="31qhkacyjt2ht">{price}</span>
        <span className={`font-display font-bold text-brand ${currency}`} data-id="element-293" data-mp="2wredoo2x6o7q">ARS</span>
      </div>
    </div>;
}